import { faArrowDown, faArrowLeft, faArrowRight, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import React, { createRef, FC, useEffect, useState } from 'react';
import * as api from '../../../api/generated';
import {
    InfoScreenLocationDisplayDirectionType,
    infoScreenLocationDisplayDirectionType,
    screenSoundType,
    ScreenSoundType,
    TicketState,
    ticketState
} from '../../../enums';
import '../../../styles/workplaceGroup.scss';
import { ai } from '../../../utils';
import { IInfoScreenColorsForm } from '../../administration/organization/generalSettings/design/GeneralSettingsDesignInfoScreen';

interface IProps {
    id: number;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
    design: IInfoScreenColorsForm;
    newVisit: IVisit;
    soundType: ScreenSoundType;
}

export interface IVisit {
    id: number;
    ticketId: number | null;
    ticketNumber: string | null;
    locationName: string | null;
    blink: boolean;
    direction: InfoScreenLocationDisplayDirectionType;
    ticketState: TicketState;
    isGroupVisit: boolean;
}

const InfoScreenDisplayLocations: FC<IProps> = (props) => {
    const [visits, setVisits] = useState<IVisit[]>([]);
    const [nextTicketToQueue, setNextToQueue] = useState<IVisit>();
    const [error, setError] = useState<string | null>(null);
    const [playSound, setPlaySound] = useState<boolean>(false);

    const [soundChar, setSoundChar] = useState<string>('letter');
    const [arrOfSounds, setArrOfSounds] = useState<string[]>(['']);
    const [soundIndex, setSoundIndex] = useState<number>(0);
    const [isAnyArrowsShown, setIsAnyArrowsShown] = useState<boolean>(false);

    let audioEl = createRef<HTMLAudioElement>();

    useEffect(() => {
        try {
            if (props.newVisit) {
                var oldVisits = [...visits];
                var existing = oldVisits.find(
                    (x) =>
                        (x.locationName == props.newVisit.locationName && !props.newVisit.isGroupVisit && x.ticketId == props.newVisit.ticketId) ||
                        (props.newVisit.isGroupVisit && props.newVisit.ticketNumber == x.ticketNumber)
                );

                if (
                    ((!props.newVisit.isGroupVisit && nextTicketToQueue?.ticketId == props.newVisit.ticketId) ||
                        (props.newVisit.isGroupVisit && props.newVisit.ticketNumber == nextTicketToQueue?.ticketNumber)) &&
                    nextTicketToQueue?.locationName == props.newVisit.locationName
                ) {
                    setNextToQueue({ ...nextTicketToQueue!, blink: false });
                    setTimeout(() => {
                        setNextToQueue(props.newVisit!);
                    }, 100);
                    PlaySoundConfiguration(props.newVisit);
                } else if (existing && props.newVisit.ticketState == ticketState.Invited) {
                    PlaySoundConfiguration(props.newVisit);
                    setVisits(resetBlink(oldVisits, props.newVisit, false));
                    setTimeout(() => {
                        setVisits(resetBlink(oldVisits, props.newVisit, true));
                    }, 100);
                } else if (existing && props.newVisit.ticketState != ticketState.Invited) {
                    setVisits(resetState(oldVisits, { ...props.newVisit }));
                } else {
                    if (props.newVisit?.ticketState == ticketState.Invited) {
                        if (nextTicketToQueue) oldVisits.unshift({ ...nextTicketToQueue!, blink: false });

                        if (oldVisits.length > 3) {
                            oldVisits.length = 3;
                        }
                        setVisits(oldVisits);
                        setNextToQueue({ ...nextTicketToQueue!, blink: false });
                        setTimeout(() => {
                            setNextToQueue(props.newVisit!);
                        }, 100);

                        PlaySoundConfiguration(props.newVisit);
                    }
                }
            }
        } catch (ex) {
            ai.appInsights.trackException({
                exception: new Error('InfoScreenLocations Error in useEffect line 123' + ex + ', ' + ex?.error),
                severityLevel: SeverityLevel.Error
            });
        }
    }, [props.newVisit]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.display.getInfoScreenDisplayParameters(props.id);

                if (response) {
                    setIsAnyArrowsShown(response.locations.filter((x) => x.direction !== infoScreenLocationDisplayDirectionType.None).length > 0);

                    const button = document.getElementById('playButton');
                    if (button) button!.innerText = response.soundType.toString();
                } else {
                    ai.appInsights.trackException({
                        exception: new Error('InfoScreenLocations no data return ' + document.getElementById('playButton')?.innerText.toString()),
                        severityLevel: SeverityLevel.Error
                    });
                }
            } catch (ex) {
                setError(ex.error);
                props.setError(ex.error);
                ai.appInsights.trackException({
                    exception: new Error('InfoScreenLocations Error in useEffect fetchData' + ex + ', ' + ex?.error),
                    severityLevel: SeverityLevel.Error
                });
            }
        };
        fetchData();
    }, []);

    function resetBlink(oldVisits: IVisit[], ticket: IVisit, boolBlink: boolean) {
        var newVisits = oldVisits.map((x: IVisit) => {
            if (x.ticketId == ticket.ticketId) {
                x.blink = boolBlink;
                x.ticketState = ticket.ticketState;
            } else if (ticket.isGroupVisit && x.isGroupVisit && x.ticketNumber == ticket.ticketNumber) {
                x.blink = boolBlink;
                x.ticketState = ticket.ticketState;
            }
            return x;
        });
        return newVisits;
    }

    function resetState(oldVisits: IVisit[], ticket: IVisit) {
        var newVisits = oldVisits.map((x: IVisit) => {
            if (x.ticketId === ticket.ticketId) {
                x.ticketState = ticket.ticketState;
                x.blink = false;
            }
            return x;
        });
        return newVisits;
    }

    function PlaySoundConfiguration(ticket: IVisit) {
        try {
            if (ticket.ticketState == ticketState.Invited && props.newVisit.ticketNumber!.length > 1) {
                if (screenSoundType.Ring == parseInt(document.getElementById('playButton')!.innerText)) {
                    document.getElementById('playButton')?.click();
                } else {
                    setPlaySound(true);
                }
                setArrOfSounds(props.newVisit!.ticketNumber!.split(''));
                setSoundIndex(0);
                setSoundChar(isNaN(parseInt(props.newVisit.ticketNumber!.split('')[0])) ? 'letter' : 'number');
            } else {
                setArrOfSounds([]);
            }
        } catch (e) {
            ai.appInsights.trackException({
                exception: new Error('InfoScreenLocations Error in PlaySoundConfiguration object not found'),
                severityLevel: SeverityLevel.Error
            });
        }
    }

    function selectNextTrack() {
        try {
            if (arrOfSounds.length && arrOfSounds[soundIndex + 1]) {
                setSoundIndex(soundIndex + 1);
                setSoundChar(isNaN(parseInt(arrOfSounds[soundIndex + 1])) ? 'letter' : 'number');
                endPlaying();
                setTimeout(() => {
                    setPlaySound(true);
                }, 1000);
            } else {
                setSoundIndex(0);
                endPlaying();
            }
        } catch (ex) {
            ai.appInsights.trackException({
                exception: new Error('InfoScreenLocations Error in selectNextTrack' + ex + ', ' + ex?.error),
                severityLevel: SeverityLevel.Error
            });
        }
    }

    function endPlaying() {
        setPlaySound(false);
    }
    const ReturnArrow = (visit: IVisit): JSX.Element => {
        switch (visit.direction) {
            case infoScreenLocationDisplayDirectionType.Top:
                return <FontAwesomeIcon className="arrowFont" icon={faArrowUp} />;
            case infoScreenLocationDisplayDirectionType.Down:
                return <FontAwesomeIcon className="arrowFont" icon={faArrowDown} />;

            case infoScreenLocationDisplayDirectionType.Right:
                return <FontAwesomeIcon className="arrowFont" icon={faArrowRight} />;

            case infoScreenLocationDisplayDirectionType.Left:
                return <FontAwesomeIcon className="arrowFont" icon={faArrowLeft} />;
            default:
                return <div></div>;
        }
    };

    function audioPlaySound() {
        try {
            audioEl.current!.play();
        } catch (ex) {
            ai.appInsights.trackException({
                exception: new Error('InfoScreenLocations Error in audioPlaySound' + ex + ', ' + ex?.error),
                severityLevel: SeverityLevel.Error
            });
        }
    }

    return (
        <>
            <button style={{ display: 'none' }} id="playButton" onClick={() => audioPlaySound()}>
                Focus input
            </button>
            <audio ref={audioEl} src={`/doorbell.mp3`} onEnded={() => endPlaying()}></audio>
            {screenSoundType.Spelling === props.soundType && playSound && (
                <audio src={`/${soundChar}s/${arrOfSounds[soundIndex]}.mp3`} autoPlay onEnded={() => selectNextTrack()}></audio>
            )}
            {!error && !visits && <> Kraunama.. </>}
            {!error && visits && (
                <div className="layout1">
                    <div className="queuesInformationContainer" style={{ backgroundColor: props.design.secondaryColor?.toString() }}>
                        {nextTicketToQueue != undefined ? (
                            <div className="queueStatusContainer">
                                {isAnyArrowsShown && (
                                    <div
                                        className={`arrowLocationContainer`}
                                        style={{
                                            backgroundColor:
                                                nextTicketToQueue.ticketState === ticketState.Invited
                                                    ? '#009245'
                                                    : props.design.primaryColor?.toString()
                                        }}
                                    >
                                        <div style={{ color: props.design.textColor?.toString() }}> {ReturnArrow(nextTicketToQueue)}</div>
                                    </div>
                                )}
                                <div
                                    style={{
                                        width: `${isAnyArrowsShown ? '39%' : '49%'}`,
                                        backgroundColor:
                                            nextTicketToQueue.ticketState === ticketState.Invited
                                                ? '#009245'
                                                : props.design.secondaryColor?.toString(),
                                        color: props.design.textColor?.toString()
                                    }}
                                    className={`ticketContainer `}
                                >
                                    <div
                                        className={`ticketText ${nextTicketToQueue && nextTicketToQueue.blink ? 'blink' : ''}`}
                                        style={{ color: props.design.textColor?.toString() }}
                                    >
                                        {nextTicketToQueue && nextTicketToQueue.ticketNumber}
                                    </div>
                                </div>
                                <div
                                    className={`workplaceLocationContainer `}
                                    style={{
                                        backgroundColor:
                                            nextTicketToQueue.ticketState === ticketState.Invited ? '#009245' : props.design.primaryColor?.toString()
                                    }}
                                >
                                    <div
                                        className={`workplaceLocationText ${nextTicketToQueue.blink ? 'blink' : ''}`}
                                        style={{ color: props.design.textColor?.toString() }}
                                    >
                                        {nextTicketToQueue.locationName && (
                                            <span
                                                style={{
                                                    fontSize:
                                                        nextTicketToQueue.locationName.length > 10
                                                            ? `${100 / nextTicketToQueue.locationName.length}vw`
                                                            : ''
                                                }}
                                            >
                                                {nextTicketToQueue.locationName}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="queueStatusContainer"></div>
                        )}
                        {isAnyArrowsShown &&
                            visits.map((x, id) => (
                                <div key={id} className="queueStatusContainer">
                                    <div
                                        className={`arrowLocationContainer `}
                                        style={{
                                            backgroundColor: x.ticketState === ticketState.Invited ? '#009245' : props.design.primaryColor?.toString()
                                        }}
                                    >
                                        <div style={{ color: props.design.textColor?.toString() }}> {ReturnArrow(x)}</div>
                                    </div>
                                    <div
                                        style={{
                                            width: '39%',
                                            backgroundColor:
                                                x.ticketState === ticketState.Invited ? '#009245' : props.design.secondaryColor?.toString(),
                                            color: props.design.textColor?.toString()
                                        }}
                                        className={`ticketContainer `}
                                    >
                                        <div className={`ticketText ${x.blink ? 'blink' : ''}`} style={{ color: props.design.textColor?.toString() }}>
                                            {x.ticketNumber}
                                        </div>
                                    </div>
                                    <div
                                        className={`workplaceLocationContainer `}
                                        style={{
                                            backgroundColor: x.ticketState === ticketState.Invited ? '#009245' : props.design.primaryColor?.toString()
                                        }}
                                    >
                                        <div
                                            className={`workplaceLocationText ${x.blink ? 'blink' : ''}`}
                                            style={{ color: props.design.textColor?.toString() }}
                                        >
                                            {x.locationName && (
                                                <span
                                                    style={{
                                                        fontSize: x.locationName.length > 10 ? `${100 / x.locationName.length}vw` : ''
                                                    }}
                                                >
                                                    {x.locationName}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        {!isAnyArrowsShown &&
                            visits.map((x, id) => (
                                <div key={id} className="queueStatusContainer">
                                    {isAnyArrowsShown && (
                                        <div className={`arrowLocationContainer`}>
                                            <div style={{ color: props.design.textColor?.toString() }}> {ReturnArrow(x)}</div>
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            width: '49%',
                                            backgroundColor:
                                                x.ticketState === ticketState.Invited ? '#009245' : props.design.secondaryColor?.toString(),
                                            color: props.design.textColor?.toString()
                                        }}
                                        className={`ticketContainer ${x.ticketState === ticketState.Invited && `firstTicketContainer`}`}
                                    >
                                        <div className={`ticketText ${x.blink ? 'blink' : ''}`} style={{ color: props.design.textColor?.toString() }}>
                                            {x.ticketNumber}
                                        </div>
                                    </div>

                                    <div
                                        className={`workplaceLocationContainer `}
                                        style={{
                                            backgroundColor: x.ticketState === ticketState.Invited ? '#009245' : props.design.primaryColor?.toString()
                                        }}
                                    >
                                        <div
                                            className={`workplaceLocationText ${x.blink ? 'blink' : ''}`}
                                            style={{ color: props.design.textColor?.toString() }}
                                        >
                                            {x.locationName && (
                                                <span
                                                    style={{
                                                        fontSize: x.locationName.length > 10 ? `${100 / x.locationName.length}vw` : ''
                                                    }}
                                                >
                                                    {x.locationName}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default InfoScreenDisplayLocations;
